import { ReactNode } from 'react';

interface Props {
  name: ReactNode;
}

const Copyright = ({ name }: Props) => (
  <>
    &copy; {name} {new Date().getFullYear()}
  </>
);

export default Copyright;
